<template>
  <QPaginatedSearchDropdown :key="resetKey" :value="value" :list-getter="getAssetTypeListFromFilter" :filter="filter"
    :min-search-char-limit="0" :allow-create="allowCreate && !SupplierReadonly" :externaledit="externaledit"
    :disableAttach="disableAttach" :clearable="clearable" :multiple="multiple" :returnobject="returnobject"
    :disabled="disabled" :outlined="outlined" :dense="dense" :loading="createLoading || loading" valuekey="Id"
    textkey="Name" :label="label ? label : $t('servicesystem.common_objects.asset_type.asset_type')"
    :placeholder="placeholder ? placeholder : $t('servicesystem.common_objects.asset_type.search_field_label')"
    :rules="rules" @input="e => $emit('input', e)" @create="e => createNew(e)"
    @FocusState="e => $emit('FocusState', e)">
    <template v-if="!hideIcon" v-slot:prepend-outer>
      <v-icon size="20">$asset_type</v-icon>
    </template>
  </QPaginatedSearchDropdown>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import QPaginatedSearchDropdown from "@/components/Inputs/QPaginatedSearchDropdown.vue";
import rules from "@/helpers/Mixins/QInputRuleMixin.js";

export default {
  name: "AssetTypeSelect2",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    label: String,
    placeholder: String,
    value: [Object, String, Number, Array],
    clearable: Boolean,
    disabled: Boolean,
    loading: Boolean,
    externaledit: Boolean,
    filter: Object,
    returnobject: Boolean,
    multiple: Boolean,
    rules: Array,
    allowCreate: Boolean,
    hideIcon: Boolean,
    outlined: Boolean,
    dense: Boolean,
    disableAttach: Boolean,
  },
  components: {
    QPaginatedSearchDropdown,
  },
  mixins: [clientAPI, rules],

  data() {
    return {
      createLoading: false,
      resetKey: 1,
    };
  },

  methods: {
    async createNew({ value, onComplete }) {
      this.createLoading = true;
      const dto = { Name: value };
      clientAPI.methods.createAssetType(dto)
        .then(async response => {
          var val = this.returnobject ? response : response.Id;
          if (this.multiple) {
            val = [...this.value, val];
          }
          this.$emit('input', val);
          this.$emit('change', val);
          await onComplete();
          //reset required to force reload while in editmode
          if (this.externaledit) {
            this.resetKey++;
          }
        })
        .finally(() => {
          this.createLoading = false;
        });
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang="scss"></style>